<template>
  <div class="ac-page">
    <div class="ac-body">
      <h1 class="ac-title">注销账号绑定的信息</h1>

      <div class="form">
        <!-- 注销账号名 -->
        <div class="ac-row">
          <label class="ac-label"><i class="req">*</i>注销账号名</label>
          <div class="ac-field">
            <input
              v-model.trim="form.userName"
              class="ac-input"
              placeholder="请输入游戏内的用户账号名"
            />
          </div>
        </div>

        <!-- 注销原因 -->
        <div class="ac-row">
          <label class="ac-label"><i class="req">*</i>注销原因</label>
          <div class="ac-field select" @click="showReason = true">
            <span class="ac-input as-text" :class="{ ph: !form.reasonLabel }">
              {{ form.reasonLabel || "请选择注销原因" }}
            </span>
            <svg class="caret" width="12" height="8" viewBox="0 0 12 8" fill="none">
              <path
                d="M1 1.5L6 6.5l5-5"
                stroke="currentColor"
                stroke-width="1.6"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </div>

        <!-- 其他原因（原因=其他 时显示） -->
        <div v-if="isOther" class="ac-row">
          <label class="ac-label"><i class="req">*</i>其他原因</label>
          <div class="ac-field is-textarea">
            <textarea
              v-model.trim="form.reason"
              class="ac-input ac-textarea"
              maxlength="500"
              placeholder="请填写你的注销原因…"
            />
          </div>
        </div>

        <!-- 姓名 -->
        <div class="ac-row">
          <label class="ac-label"><i class="req">*</i>姓名</label>
          <div class="ac-field">
            <input
              v-model.trim="form.idCardName"
              class="ac-input"
              placeholder="请输入账号绑定的姓名"
            />
          </div>
        </div>

        <!-- 身份证 -->
        <div class="ac-row">
          <label class="ac-label"><i class="req">*</i>身份证</label>
          <div class="ac-field">
            <input
              v-model.trim="form.idCardNum"
              maxlength="18"
              class="ac-input"
              placeholder="请输入账号绑定的身份证"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="ac-footer">
      <button class="ac-btn is-primary" @click="onNext">下一步</button>
      <button class="ac-btn is-text" @click="onGiveUp">我不注销了</button>
    </div>

    <!-- 注销原因选择器 -->
    <Popup v-model="showReason" position="bottom" round>
      <Picker
        show-toolbar
        title="注销原因"
        value-key="text"
        :columns="REASONS"
        :default-index="reasonIndex"
        @cancel="showReason = false"
        @confirm="onReasonConfirm"
      />
    </Popup>

    <!-- 确认注销弹窗 -->
    <div v-if="showConfirm" class="scrim" @click.self="showConfirm = false">
      <div class="modal">
        <h2 class="modal-title">确定要注销账号吗？</h2>
        <p class="modal-text">
          亲爱的玩家，感谢你对我们游戏的支持。注销账号后，你的所有游戏账号数据将会清除，<b>不可恢复</b>。确定注销吗？
        </p>
        <div class="modal-actions">
          <button class="ac-btn is-ghost" @click="showConfirm = false">我再想想</button>
          <button class="ac-btn is-primary" :disabled="submitting" @click="onConfirm">
            {{ submitting ? "提交中..." : "确认注销" }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Popup, Picker } from "vant";
import { mapState } from "vuex";
import { reg, REASONS, OTHER_REASON } from "./config";
import { submitCancelApi } from "@/apis/accountCancel";

export default {
  name: "AccountCancelForm",
  components: { Popup, Picker },
  data() {
    return {
      REASONS,
      showReason: false,
      showConfirm: false,
      submitting: false,
      form: {
        userName: "",
        reasonType: "",
        reasonLabel: "",
        reason: "",
        idCardName: "",
        idCardNum: "",
      },
    };
  },
  computed: {
    ...mapState("accountCancel", {
      storeForm: "form",
    }),
    isOther() {
      return this.form.reasonType === OTHER_REASON;
    },
    reasonIndex() {
      const i = REASONS.findIndex((r) => r.value === this.form.reasonType);
      return i < 0 ? 0 : i;
    },
  },
  created() {
    if (!this.$store.state.accountCancel.closeToken) {
      this.$router.replace({ name: "gameJump-accountCancelLogin" });
      return;
    }
    // 回填登录时拿到的账号信息（注销账号名）
    this.form = { ...this.form, ...this.storeForm };
  },
  methods: {
    onReasonConfirm(item) {
      this.form.reasonType = item.value;
      this.form.reasonLabel = item.text;
      if (!this.isOther) this.form.reason = "";
      this.showReason = false;
    },
    validate() {
      if (!this.form.userName) {
        Toast("请输入注销账号名");
        return false;
      }
      if (!this.form.reasonType) {
        Toast("请选择注销原因");
        return false;
      }
      if (this.isOther && !this.form.reason) {
        Toast("请填写其他原因");
        return false;
      }
      if (!this.form.idCardName) {
        Toast("请输入姓名");
        return false;
      }
      if (!reg.idCard.test(this.form.idCardNum)) {
        Toast("请输入正确的身份证号");
        return false;
      }
      return true;
    },
    onNext() {
      if (!this.validate()) return;
      this.$store.commit("accountCancel/SET_FORM", this.form);
      this.showConfirm = true;
    },
    onGiveUp() {
      // 放弃注销：回到登录页（登录页 created 会清空用户信息）
      this.$router.replace({ name: "gameJump-accountCancelLogin" });
    },
    async onConfirm() {
      const { closeToken, userId } = this.$store.state.accountCancel;
      this.submitting = true;
      try {
        const { content = {} } = await submitCancelApi({
          close_token: closeToken,
          user_id: userId,
          user_name: this.form.userName,
          reason_type: this.form.reasonType,
          reason: this.isOther ? this.form.reason : "",
          id_card_name: this.form.idCardName,
          id_card_num: this.form.idCardNum,
        });
        this.$store.commit("accountCancel/SET_RESULT", {
          applyTime: content.apply_time,
          expireTime: content.expire_time,
          auditDays: content.audit_days,
        });
        this.showConfirm = false;
        this.$router.push({ name: "gameJump-accountCancelSuccess" });
      } catch (e) {
        // 错误提示已由响应拦截统一处理
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./styles.scss";

.form {
  margin-top: 8px;
}

.ac-input {
  flex: 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  color: $ac-text;
  font-size: 16px;

  &::placeholder {
    color: rgba(27, 31, 39, 0.42);
  }

  &.as-text.ph {
    color: rgba(27, 31, 39, 0.42);
  }
}

.ac-textarea {
  width: 100%;
  height: 68px;
  resize: none;
  line-height: 1.5;
}

.select {
  justify-content: space-between;

  .caret {
    flex-shrink: 0;
    margin-left: 12px;
    color: $ac-sub;
  }
}

// 确认弹窗
.scrim {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 36px;
  background: rgba(20, 25, 35, 0.45);
}

.modal {
  width: 100%;
  padding: 26px 22px 20px;
  background: #fff;
  border-radius: 18px;
}

.modal-title {
  margin-bottom: 14px;
  font-size: 19px;
  font-weight: 700;
  text-align: center;
}

.modal-text {
  margin-bottom: 22px;
  color: #3a3f4a;
  font-size: 14px;
  line-height: 1.7;

  b {
    color: $ac-brand;
  }
}

.modal-actions {
  display: flex;
  gap: 12px;

  .ac-btn {
    flex: 1;
  }

  .ac-btn + .ac-btn {
    margin-top: 0;
  }
}
</style>
